export default __webpack_public_path__ + "static/media/g2020-4.a915d12d.jpeg";